import React from 'react'
import { connect } from 'react-redux'
import { hasChangedValues, getFormValue, changeItemsValue } from '../../public/utility/formValues'
import MethodApplyDetail from './MethodApplyDetail'
class MethodApplyTypeSelectDiv extends React.Component {
    state = {
    }

    componentDidMount = () => {
    }

    handlerClose = () => {
        const { onClose, onSave } = this.props
        onClose && onClose()
        // onSave && onSave()
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    handlerSave = () => {
        const { onClose, onSave, showDetail } = this.props
        const { changedValues基本信息 } = this.state
        onClose && onClose()
        showDetail(props => <MethodApplyDetail {...props} id={0} applyType={changedValues基本信息.申请类型} onSave={onSave} />)
        // Tyan.pubForm.showDialog('新方法申请/核准表', props => <MethodApplyDetail {...props} id={0} applyType={changedValues基本信息.申请类型} onSave={onSave} />)

    }

    fieldset基本信息 = () => {
        return [
            { _radio: '申请类型', minWidth: '90%', items: ['新增', '修改'] },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body, id } = this.props
        
        return <Body data={this} minWidth="400"
            controls={
                [
                    { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.bChanged(), },
                    { _button: '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(),/*   fullblock: true  */ },
                ]}
        />
    }
}

export default connect()(MethodApplyTypeSelectDiv)